import { IFormItem, IFormItemVm } from "../../../models/response/form/IFormItem";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objFormItemDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IFormItem[],
    LOAD_ERROR: "",
    SELECT_START: "",
    SELECT_SUCCESS: [] as IFormItemVm[],
    SELECT_ERROR: "",
    SHOW_EDIT_MODAL: {} as IFormItem | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IFormItem,
    SAVE_SUCESS: {} as IFormItem,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: "",
    SAVES_START: {} as IFormItem[],
    SAVES_SUCESS: {} as IFormItem[],
    SAVES_ERROR: "",
};

export const eFormItemActionTypeIds = generateActionTypeIds(objFormItemDefine, "FORM_ITEM")
export type IFormItemActionTypes = IGenericActionType<typeof objFormItemDefine, "FORM_ITEM">